<template>
  <div class="relatorio">
    <div class="descTable">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h2 style="color:white; box-shadow: 1px 1px 8px black;">
            <svg style="width:24px;height:24px;margin-left: 87px;margin-bottom: -4px;" viewBox="0 0 24 24">
              <path fill="#fff"
                d="M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z">
              </path>
            </svg>
            Valida OCR
          </h2>
        </v-flex>
      </v-layout>
    </div>

    <v-card flat style="width: 90%;margin: 0 auto 40px auto;padding: 41px 41px 0px 41px;background-color: #efefef;" id="">
      <div v-if="successMessage">
        <v-alert :value="true" type="success" :dismissible="true" style="padding:5px;">
          {{ successMessage }}

        </v-alert>
      </div>
      <div v-if="errorMessage">
        <v-alert :value="true" type="error" :dismissible="true" style="padding:5px;">
          {{ errorMessage }}
        </v-alert>
      </div>
      <div style="display: flex; align-items: center">
        <v-text-field return-masked-value mask="##/##/####" clearable v-model="dataIni"
          label="Data Inicio"></v-text-field>

        <v-text-field return-masked-value mask="##/##/####" clearable style="margin-left: 30px;" v-model="dataFim"
          label="Data Fim"></v-text-field>
        <v-text-field return-masked-value mask="##.###.###/####-##" clearable style="margin-left: 30px;" v-model="cnpj"
          label="CNPJ Empresa Upload"></v-text-field>
        <!-- <v-text-field clearable style="margin-left: 30px;" v-model="verificado" label="Verificado"></v-text-field> -->
        <v-select v-model="verificado" clearable style="margin-left: 30px;" :items="['Sim', 'Não']"
          label="Verificado"></v-select>
        <v-select v-model="status_ocr" clearable style="margin-left: 30px; overflow-y: hidden;"
          :items="['Processada', 'pendente', 'Sucesso Manual', 'Desconsiderado', 'Boleto', 'Falha', 'Duplicada','Processada IA']"
          label="Status OCR"></v-select>
        <!-- <v-btn style="background: teal; color: white;" @click="vOcrUpdate">Buscar</v-btn> -->
      </div>
      <div>
        <v-card>
          <v-card-title>
            <v-btn style="background: teal; color: white;" @click="vOcrUpdate">Buscar</v-btn>
            <v-btn style="background: teal; color: white;" @click="vOcrSevenDays">7 dias</v-btn>
            <v-btn style="background: teal; color: white;" @click="vOcrCurrentMonth">Mês Atual</v-btn>
            <v-btn style="background: teal; color: white;" @click="vOcrLastMonth">Mês Anterior</v-btn>
            <v-btn style="background: teal; color: white;" @click="vOcrClear">Limpar filtros</v-btn>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="body" :search="search" hide-actions :pagination.sync="pagination"
            class="elevation-1" :loading="isLoading" id="table">
            <!-- <template v-if="isLoading" v-slot:progress>
            <v-progress-linear v-if="isLoading" color="blue" indeterminate></v-progress-linear>
          </template> -->

            <v-progress-linear slot="progress" color="teal" height="20" indeterminate
              style="z-index: 3;"></v-progress-linear>

            <template slot="no-data">
              <v-alert :value="true" color="indigo darken-4" icon="info" outline>
                <article v-if="isLoading">Motor Fiscal está buscando as informações</article>
                <article v-if="!isLoading">
                  Dados não encontrados
                </article>
              </v-alert>
            </template>

            <template v-if="!isLoading" v-slot:items="props">
              <tr :style="{ 'background': props.item.pathPdf ? '' : '#ffe5e3' }">
                <td class="text-xs-center"><span class="ocrLink" @click="vOcrOpenFile(props.item)">ACESSAR</span></td>
                <td class="text-xs-center">
                  <v-chip small :color="props.item.verificadoOcr !== 'None' && props.item.verificadoOcr ? 'green' : 'red'"
                    text-color="white">
                    <span>{{ props.item.verificadoOcr !== 'None' && props.item.verificadoOcr ? 'Sim' : 'Não' }}</span>
                  </v-chip>
                </td>
                <td class="text-xs-center">
                  <v-chip small :color="props.item.ocr_status ?
                    props.item.ocr_status === 'Processada' ?
                      'green' :
                      props.item.ocr_status === 'pendente' ?
                        'orange' :
                        props.item.ocr_status === 'Sucesso Manual' ?
                          'blue' :
                          props.item.ocr_status === 'Falha' ?
                            'red' : 
                            props.item.ocr_status === 'Processada IA' ?
                            'purple' :'grey darken-3'
                    : 'grey darken-3'" text-color="white">
                    <span>{{ props.item.ocr_status ? props.item.ocr_status : 'Não possui' }}</span>
                  </v-chip>
                </td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.empresa.razao + ' ' +
                  props.item.empresa.cnpj }}</td>
                <td class="text-xs-center">{{ Number(props.item.numeroNfe) }}</td>
                <td class="text-xs-center">{{ props.item.codVerificacao }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.cnpjCpfTomador != undefined ?
                  (props.item.cnpjCpfTomador.length > 11 ?
                    props.item.cnpjCpfTomador.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") :
                    props.item.cnpjCpfTomador.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4")) : '' }}</td>

                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.razaoTomador }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.dtEmissaoNfe }}</td>

                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.ocr_log ? props.item.ocr_log : '' }}
                </td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.cnpjCpfPrestador != undefined ?
                  (props.item.cnpjCpfPrestador.length > 11 ?
                    props.item.cnpjCpfPrestador.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") :
                    props.item.cnpjCpfPrestador.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4")) : '' }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.razaoPrestador }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.createdAt }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.codServico }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.aliqServico }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.ISS }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.ISSRetido }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item._id }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.nome_municipio }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.UFPrestador }}</td>
                <td style="white-space: nowrap;" class="text-xs-center">{{ props.item.dt_processamento != undefined ?
                  props.item.dt_processamento.substring(0, 16) : "" }}</td>
              </tr>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                "{{ search }}" não encontrado.
              </v-alert>
            </template>

            <template slot="pageText" slot-scope="props">
              <strong>
                Exibindo {{ props.pagination.page }} - {{ 14 }} do total de {{ props.pages }}
                <span>Notas</span>
              </strong>
            </template>

          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
          </div>
        </v-card>
      </div>
    </v-card>


    <v-dialog v-model="dialog" v-if="dialog" persistent @keydown.esc="dialog = false">
      <v-card>
        <v-card-text style="display: flex; padding-top: 0; padding-bottom: 0;">
          <v-container grid-list-md style="margin-top: 0; overflow: scroll; height: 90vh">
            <div style="display: flex; justify-content: flex-end; flex-wrap: wrap;">
              <v-btn
                :disabled="!docPrestador || !docTomador || !cidade || !estado || !editedItem.vlrServico || !editedItem.numeroNfe || !editedItem.razaoTomador || !editedItem.razaoPrestador || !editedItem.codVerificacao || !editedItem.dtEmissaoNfe || !editedItem.descServico || !editedItem.codServico || !editedItem.discriminacao || !editedItem.aliqServico || (editedItem.cnpjCpfPrestador === editedItem.cnpjCpfTomador)"
                v-if="!isBtnLoading" style="background: teal; color: white;" @click="vOcrSave">Salvar</v-btn>
              <v-btn :disabled="desabilita_campo" v-if="!isBtnLoading" style="background: teal; color: white;"
                @click="VeriricaDuplicidade">Verificar Duplicidade</v-btn>
              <v-btn v-if="!isBtnLoading" style="background: teal; color: white;" @click="vOcrVerify">Verificar</v-btn>
              <v-btn v-if="!isBtnLoading" style="background: teal; color: white;"
                @click="vOcrAlterState('pendente')">Pendente</v-btn>
              <v-btn v-if="!isBtnLoading" style="background: teal; color: white;"
                @click="vOcrAlterState('duplicada')">Duplicada</v-btn>
              <v-btn v-if="!isBtnLoading" style="background: red; color: white;"
                @click="vOcrAlterState('desconsiderado')">Desconsiderar</v-btn>
              <v-btn v-if="!isBtnLoading" style="background: red; color: white;"
                @click="vOcrAlterState('boleto')">Boleto</v-btn>
              <v-btn v-if="isBtnLoading" style="background: gray; color: black;" disabled>Processando...</v-btn>
              <v-btn @click="dialog = false">Fechar</v-btn>
            </div>
            <v-divider style="margin-bottom: 10px;"></v-divider>
            <div v-if="successMessageDuplicidade">
              <v-alert :value="true" type="success" :dismissible="true" style="padding:5px;">
                {{ successMessageDuplicidade }}
              </v-alert>
            </div>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field disabled v-model="editedItem._id" label="ID"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :rules="validationRules" @blur="regra_verifica_duplicidade()" v-model="editedItem.numeroNfe"
                  label="Número da NFe"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :rules="validationRules" @blur="regra_verifica_duplicidade()" id="codUpper"
                  v-model="editedItem.codVerificacao" label="Código Verificação"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field :mask="mask.cnpjPrestador" @keydown.delete="mask ? mask.cnpjPrestador = '' : ''"
                  @keyup="trocaCampoCpfCnpjPrestador($event, editedItem.cnpjCpfPrestador)"
                  @blur="buscaReceitaPrestador(); regra_verifica_duplicidade()" v-model="editedItem.cnpjCpfPrestador" label="CNPJ/CPF Prestador"
                  clearable
                  :rules="editedItem.cnpjCpfPrestador ? (editedItem.cnpjCpfPrestador.length > 11 ? cnpjRules : cpfRules) : cnpjRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete v-model="estado" :autocomplete="false" validate-on-blur item-text="sigla"
                  :items="arrayEstados" label="Estado Prestador" clearable persistent-hint
                  no-data-text="Consulta de Estado indisponível" return-object @change="getMunicipiosPrestador"
                  :rules="validationRules" @blur="regra_verifica_duplicidade()"></v-autocomplete>
                <!-- <v-text-field v-model="editedItem.UFPrestador" label="Estado Prestador"></v-text-field> -->
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete label="Cidade Prestador" :autocomplete="false" validate-on-blur item-text="nome"
                  :items="arrayMunicipiosPrestador" v-model="cidade" clearable no-data-text="Selecione um Estado" return-object
                  :rules="validationRules" @blur="regra_verifica_duplicidade()"></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-divider style="margin-bottom: 10px;"></v-divider>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.serie" label="Serie da NFe"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field :disabled="desabilita_campo" :rules="validationRules" return-masked-value
                  mask="##/##/#### ##:##:##" v-model="editedItem.dtEmissaoNfe" label="Data Emissão"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.numRPS" label="Número RPS"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.serieRPS" label="Serie RPS"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.tipoRPS" label="Tipo RPS"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md6>
                <v-text-field :disabled="desabilita_campo" return-masked-value mask="##/##/#### ##:##:##"
                  v-model="editedItem.dtEmissaoRPS" label="Data de Emissão RPS"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.numLote"
                  label="Número do Lote"></v-text-field>
              </v-flex>
            </v-layout>

            <v-divider style="margin-bottom: 10px;"></v-divider>

            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-textarea :disabled="desabilita_campo" :rules="validationRules" rows="1" auto-grow style="width: 100%;"
                  v-model="editedItem.razaoPrestador" label="Razão Prestador"></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <!-- <v-text-field :disabled="desabilita_campo" v-model="editedItem.opcaoSimples" label="Opção Simples"></v-text-field> -->
                <v-select :disabled="desabilita_campo" v-model="editedItem.enderecoPrestadorTipoLogradouro" :items="[
                  { text: 'Rua', value: 'Rua' },
                  { text: 'Avenida', value: 'Avenida' },
                  { text: 'Travessa', value: 'Travessa' },
                  { text: 'Praça', value: 'Praça' },
                  { text: 'Alameda', value: 'Alameda' },
                  { text: 'Largo', value: 'Largo' }
                ]" label="Tipo Logradouro Prestador"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.enderecoPrestadorNumeroEndereco"
                  label="Número endereço Prestador"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.enderecoPrestadorBairro"
                  label="Bairro Prestador"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.enderecoPrestadorComplementoEndereco"
                  label="Complemento endereço Prestador"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.enderecoPrestadorLogradouro"
                  label="Endereço Prestador"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.inscPrestador"
                  label="Inscrição Municipal Prestador"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.inscriEsPrestador"
                  label="Inscrição Estadual Prestador"></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.enderecoPrestadorCEP"
                  label="CEP Prestador"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.telefonePrestador"
                  label="Telefone Prestador"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.emailPrestador" label="Email Prestador" :rules="validaEmail"
                  validate-on-blur></v-text-field>
              </v-flex>
              <!-- <v-text-field :disabled="desabilita_campo" v-model="editedItem.nome_municipio" label="Cidade Prestador"></v-text-field> -->
            </v-layout>

            <v-divider style="margin-bottom: 10px;"></v-divider>

            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field :disabled="desabilita_campo" :mask="mask.cnpjTomador"
                  @keydown.delete="mask ? mask.cnpjTomador = '' : ''"
                  @keyup="trocaCampoCpfCnpjTomador($event, editedItem.cnpjCpfTomador)" v-model="editedItem.cnpjCpfTomador"
                  @blur="buscaReceitaTomador()"
                  label="CNPJ/CPF Tomador" clearable
                  :rules="editedItem.cnpjCpfTomador ? (editedItem.cnpjCpfTomador.length > 11 ? cnpjRules : cpfRules) : cnpjRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete v-model="estadoTomador" :autocomplete="false" validate-on-blur item-text="sigla"
                  :items="arrayEstados" label="Estado Tomador" clearable persistent-hint
                  no-data-text="Consulta de Estado indisponível" return-object @change="getMunicipiosTomador"
                  :rules="validationRules" :disabled="desabilita_campo"></v-autocomplete>
                <!-- <v-text-field v-model="editedItem.UFPrestador" label="Estado Prestador"></v-text-field> -->
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete label="Cidade Tomador" :autocomplete="false" validate-on-blur item-text="nome"
                  :items="arrayMunicipiosTomador" v-model="cidadeTomador" clearable no-data-text="Selecione um Estado" return-object
                  :rules="validationRules" :disabled="desabilita_campo"></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <!-- <v-text-field :disabled="desabilita_campo" v-model="editedItem.razaoTomador" label="Razão Tomador"></v-text-field> -->
                <v-textarea :disabled="desabilita_campo" :rules="validationRules" rows="1" auto-grow style="width: 100%;"
                  v-model="editedItem.razaoTomador" label="Razão Tomador"></v-textarea>
              </v-flex>
           

              <v-flex xs12 sm6 md4>
                <!-- <v-text-field :disabled="desabilita_campo" v-model="editedItem.opcaoSimples" label="Opção Simples"></v-text-field> -->
                <v-select :disabled="desabilita_campo" v-model="editedItem.enderecoTomadorTipoLogradouro" :items="[
                  { text: 'Rua', value: 'Rua' },
                  { text: 'Avenida', value: 'Avenida' },
                  { text: 'Travessa', value: 'Travessa' },
                  { text: 'Praça', value: 'Praça' },
                  { text: 'Alameda', value: 'Alameda' },
                  { text: 'Largo', value: 'Largo' }
                ]" label="Tipo Logradouro Tomador"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.enderecoTomadorNumeroEndereco"
                  label="Número endereço Tomador"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.enderecoTomadorBairro"
                  label="Bairro Tomador"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.enderecoTomadorLogradouro"
                  label="Endereço Tomador"></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.enderecoTomadorComplementoEndereco"
                  label="Complemento endereço Tomador"></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.enderecoTomadorCEP"
                  label="CEP Tomador"></v-text-field>
              </v-flex>

              

            
              
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.emailTomador" label="Email Tomador" :rules="validaEmail"
                  validate-on-blur></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.inscTomador"
                  label="Inscrição Municipal Tomador"></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider style="margin-bottom: 10px;"></v-divider>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-textarea :disabled="desabilita_campo" :rules="validationRules" rows="2" auto-grow
                  style="width: 100%;font-size: 0.8em;" v-model="editedItem.discriminacao"
                  label="Discriminacao"></v-textarea>
              </v-flex>
            </v-layout>

            <v-divider style="margin-bottom: 10px;"></v-divider>

            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field :disabled="desabilita_campo" :rules="validationRules" v-model="editedItem.codServico"
                  label="Cod Serviço / Atividade"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <!-- <v-text-field :disabled="desabilita_campo" v-model="editedItem.descServico" label="Desc Serviço"></v-text-field> -->
                <v-textarea :disabled="desabilita_campo" :rules="validationRules" rows="1" auto-grow
                  style="width: 100%;font-size: 0.8em;" v-model="editedItem.descServico"
                  label="Desc Serviço / Atividade"></v-textarea>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.lei.codigo" label="Cod Lei"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <!-- <v-text-field :disabled="desabilita_campo" v-model="editedItem.lei.descricao" label="Desc Lei"></v-text-field> -->
                <v-textarea :disabled="desabilita_campo" rows="1" auto-grow style="width: 100%;font-size: 0.8em;"
                  v-model="editedItem.lei.descricao" label="Desc Lei"></v-textarea>
              </v-flex>
            </v-layout>

            <v-divider style="margin-bottom: 10px;"></v-divider>

            <v-layout wrap>
              <v-flex xs2 sm2 md2>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.PIS" label="PIS"></v-text-field>
              </v-flex>
              <v-flex xs2 sm2 md3>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.COFINS" label="COFINS"></v-text-field>
              </v-flex>
              <v-flex xs2 sm2 md2>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.IR" label="IR"></v-text-field>
              </v-flex>
              <v-flex xs2 sm2 md2>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.INSS" label="INSS"></v-text-field>
              </v-flex>
              <v-flex xs2 sm2 md3>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.CSLL" label="CSLL"></v-text-field>
              </v-flex>
            </v-layout>

            <v-divider style="margin-bottom: 10px;"></v-divider>

            <v-layout wrap>
              <v-flex xs2 sm4 md3>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.ISS" label="ISS"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <!-- <v-text-field :disabled="desabilita_campo" v-model="editedItem.ISSRetido" label="ISS Retido"></v-text-field> -->
                <v-select :disabled="desabilita_campo" v-model="editedItem.ISSRetido"
                  :items="[{ text: 'Sim', value: 'true' }, { text: 'Não', value: 'false' }]" label="ISS Retido"></v-select>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <v-text-field :disabled="desabilita_campo" :rules="validationRules" v-model="editedItem.aliqServico"
                  label="Aliq Serviço"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.deducoes" label="Deduções"></v-text-field>
              </v-flex>
              <v-flex xs12 sm7 md7>
                <!-- <v-text-field :disabled="desabilita_campo" v-model="editedItem.opcaoSimples" label="Opção Simples"></v-text-field> -->
                <v-select :disabled="desabilita_campo" v-model="editedItem.opcaoSimples" :items="[
                  { text: 'Não optante pelo Simples Federal nem Municipal', value: '0' },
                  { text: 'Optante pelo Simples Federal (Alíquota de 1,0%)', value: '1' },
                  { text: 'Optante pelo Simples Federal (Alíquota de 0,5%)', value: '2' },
                  { text: 'Optante pelo Simples Municipal.', value: '3' },
                  { text: 'Optante pelo Simples Nacional.', value: '4' },
                  { text: 'Não Contratado', value: '5' }
                ]" label="Opção Simples"></v-select>
              </v-flex>
              <v-flex xs12 sm5 md5>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.outrasRetencoes"
                  label="Outras Retenções"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <!-- <v-text-field :disabled="desabilita_campo" v-model="editedItem.tribNfe" label="Trib NFe"></v-text-field> -->
                <v-select :disabled="!docPrestador || !cidade || !editedItem.numeroNfe || !editedItem.codVerificacao"
                  v-model="editedItem.tribNfe" :items="[
                    { text: 'Tributado em São Paulo.', value: 'T' },
                    { text: 'Tributado Fora de São Paulo.', value: 'F' },
                    { text: 'Tributado em São Paulo, porém Isento.', value: 'A' },
                    { text: 'Tributado Fora de São Paulo, porém Isento.', value: 'B' },
                    { text: 'Tributado em São Paulo com isenção parcia.', value: 'D' },
                    { text: 'Tributado em São Paulo, porém com indicação de imunidade subjetiva.', value: 'M' },

                    { text: 'Tributado Fora de São Paulo, porém com indicação de imunidade subjetiva.', value: 'N' },
                    { text: 'Tributado em São Paulo, porém com indicação de imunidade objetiva.', value: 'R' },
                    { text: 'Tributado fora de São Paulo, porém com indicação de imunidade objetiva.', value: 'S' },
                    { text: 'Tributado em São Paulo, porém Exigibilidade Suspensa.', value: 'X' },
                    { text: 'Tributado Fora de São Paulo, porém Exigibilidade Suspensa.', value: 'V' },
                    { text: 'Exportação de Serviços.', value: 'P' },
                    { text: 'Upload, sem informação de tributação.', value: 'U0' },
                  ]" label="Trib NFe"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" v-model="editedItem.vlrCredito"
                  label="Valor Crédito"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :disabled="desabilita_campo" :rules="validationRules" v-model="editedItem.vlrServico"
                  label="Valor Serviço"></v-text-field>
              </v-flex>


            </v-layout>
            <div style="display: flex; justify-content: flex-end; flex-wrap: wrap;">
              <v-btn
                :disabled="!docPrestador || !docTomador || !cidade || !estado || !editedItem.vlrServico || !editedItem.numeroNfe || !editedItem.razaoTomador || !editedItem.razaoPrestador || !editedItem.codVerificacao || !editedItem.dtEmissaoNfe || !editedItem.descServico || !editedItem.codServico || !editedItem.discriminacao || !editedItem.aliqServico || (editedItem.cnpjCpfPrestador === editedItem.cnpjCpfTomador)" 
                v-if="!isBtnLoading" style="background: teal; color: white;" @click="vOcrSave">Salvar</v-btn>
              <v-btn v-if="!isBtnLoading" style="background: teal; color: white; " @click="vOcrVerify">Verificar</v-btn>
              <v-btn v-if="!isBtnLoading" style="background: teal; color: white;"
                @click="vOcrAlterState('pendente')">Pendente</v-btn>
              <v-btn v-if="!isBtnLoading" style="background: teal; color: white;"
                @click="vOcrAlterState('duplicada')">Duplicada</v-btn>
              <v-btn v-if="!isBtnLoading" style="background: red; color: white;"
                @click="vOcrAlterState('desconsiderar')">Desconsiderar</v-btn>
              <v-btn v-if="!isBtnLoading" style="background: red; color: white;"
                @click="vOcrAlterState('boleto')">Boleto</v-btn>
              <v-btn v-if="isBtnLoading" style="background: gray; color: black;" disabled>Processando...</v-btn>
              <v-btn @click="dialog = false">Fechar</v-btn>
            </div>
          </v-container>

          <iframe style="width: 100%; height: 90vh;"
            :src="'data:application/pdf;base64,' + encodeURIComponent(this.ocrFile)" frameborder="0" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <div v-if="isFileLoading" class="cont-ocr">
      <!-- <v-progress-circular
          :size="70"
          :width="7"
          color="teal"
          indeterminate
          class="load-ocr"
        ></v-progress-circular> -->
    </div>



  </div>
</template>
<script>
import EmpresasService from "@/domain/conta/empresa/EmpresaService.js";
import { getNfseOcr, getFileOcr, verifyOcr, saveOcr, denyOcr, verifyDuplicate } from '../../../domain/notas/nfseOcr/NfseOcrService';
import Conta from "../../../domain/conta/Conta";

export default {
  props: {
    conta: this.conta
  },
  mounted: function () {
    this.vOcrUpdate();
    this.getEstados;
    this.service = new EmpresasService(this.$http);
  },
  data() {
    return {
      estado: '',
      cidade: '',
      estadoTomador: '',
      cidadeTomador: '',
      arrayEstados: [],
      arrayMunicipiosPrestador: [],
      arrayMunicipiosTomador: [],
      mask: { cnpjTomador: "", cnpjPrestador: "" },
      status_ocr: 'pendente',
      successMessage: '',
      successMessageDuplicidade: '',
      errorMessage: '',
      desabilita_campo: true,
      isBtnLoading: false,
      isFileLoading: false,
      dataIni: '',
      dataFim: '',
      cnpj: '',
      verificado: '',
      ocrFile: '',
      isLoading: false,
      emailInvalido: false,
      dialog: false,
      search: '',
      pagination: {
        rowsPerPage: 10,
        totalItems: 0,
      },
      selected: [],
      headers: [
        { text: 'Ações', align: 'center', sortable: false, value: '' },
        { text: 'Verificado', align: 'center', value: 'verificadoOcr' },
        { text: 'Status OCR', align: 'center', value: 'ocr_status' },
        { text: 'Empresa Upload', align: 'center', value: 'empresa.razao' },
        { text: 'Número', align: 'center', value: 'numeroNfe' },
        { text: 'Código Verificação', align: 'center', value: 'codVerificacao' },
        { text: 'CNPJ Tomador', align: 'center', value: 'cnpjCpfTomador' },
        { text: 'Razão Tomador', align: 'center', value: 'razaoTomador' },
        { text: 'Data Emissão', align: 'center', value: 'dtEmissaoNfe' },
        { text: 'Log OCR', align: 'center', value: 'ocr_log' },
        { text: 'CNPJ Prestador', align: 'center', value: 'cnpjCpfPrestador' },
        { text: 'Razão Prestador', align: 'center', value: 'razaoPrestador' },
        { text: 'Data de criação', align: 'center', value: 'createdAt' },
        { text: 'Código de Serviço', align: 'center', value: 'codServico' },
        { text: 'Percentual ISS', align: 'center', value: 'aliqServico' },
        { text: 'Valor ISS', align: 'center', value: 'ISS' },
        { text: 'ISS Retido', align: 'center', value: 'ISSRetido' },
        { text: 'ID', align: 'center', value: '_id' },
        { text: 'Nome do Municipio Prestador', align: 'center', value: 'nome_municipio' },
        { text: 'UF Prestador', align: 'center', value: 'UFPrestador' },
        { text: 'Data de Processamento', align: 'center', value: 'dt_processamento' }
      ],
      body: [],
      editedItem: {},
      editedIndex: -1,
      docPrestador: false,
      docTomador: false,
      cpfRules: [
        v => !!v || "Campo obrigatório",
        cpf => {
          this.cnpjCpfInvalido(cpf, false);
          let sum, rest;
          if (
            cpf === undefined ||
            cpf === null ||
            cpf.trim().length === 0 ||
            cpf === "00000000000" ||
            cpf === "11111111111" ||
            cpf === "22222222222" ||
            cpf === "33333333333" ||
            cpf === "44444444444" ||
            cpf === "55555555555" ||
            cpf === "66666666666" ||
            cpf === "77777777777" ||
            cpf === "88888888888" ||
            cpf === "99999999999"
          ) {
            return "CPF inválido";
          }
          cpf = cpf
            .replace(".", "")
            .replace(".", "")
            .replace("-", "");

          sum = 0;
          for (let i = 1; i <= 9; i++) {
            sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
          }
          rest = (sum * 10) % 11;

          if (rest === 10 || rest === 11) {
            rest = 0;
          }
          if (rest !== parseInt(cpf.substring(9, 10))) {
            return "CPF inválido";
          }

          sum = 0;
          for (let i = 1; i <= 10; i++) {
            sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
          }
          rest = (sum * 10) % 11;

          if (rest === 10 || rest === 11) {
            rest = 0;
          }
          if (rest !== parseInt(cpf.substring(10, 11))) {
            return "CPF inválido";
          }

          this.cnpjCpfInvalido(cpf, true);
          return true;
        }
      ],

      cnpjRules: [
        v => !!v || "Campo obrigatório",
        v => {
          this.cnpjCpfInvalido(v, false);

          if (v == null) {
            return false;
          }
          var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

          if ((v = v.replace(/[^\d]/g, "")).length != 14) return "CNPJ inválido";

          if (/0{14}/.test(v)) return "CNPJ inválido";

          for (var i = 0, n = 0; i < 12; n += v[i] * b[++i]);
          if (v[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

          for (var i = 0, n = 0; i <= 12; n += v[i] * b[i++]);
          if (v[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

          this.cnpjCpfInvalido(v, true);

          return true;
        }
      ],
    };
  },
  computed: {
    pages() {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    
    buscaReceitaPrestador() {
      if (this.editedItem.cnpjCpfPrestador){
          this.service.getAPIReceita(this.editedItem.cnpjCpfPrestador).then(success => {
                    if (
                      success &&
                      success.status == 200 &&
                      success.body.status != "ERROR"
                    ) {
                      this.editedItem.razaoPrestador = success.body.nome;
                      this.editedItem.enderecoPrestadorLogradouro = success.body.logradouro;
                      this.editedItem.enderecoPrestadorCEP = success.body.cep;
                      this.editedItem.enderecoPrestadorBairro = success.body.bairro;
                      this.editedItem.inscPrestador = success.body.inscricao_municipal;
                      this.editedItem.inscriEsPrestador = success.body.inscricao_estadual;
                      this.editedItem.telefonePrestador = success.body.telefone;
                      this.editedItem.emailPrestador = success.body.email;
                      this.editedItem.enderecoPrestadorComplementoEndereco = success.body.complemento;
                      
                      let auxEstado;
                      this.uf = this.arrayEstados.forEach(item => {
                        if (item.sigla == success.body.uf) {
                          auxEstado = item;
                        }
                      });
                      this.estado = auxEstado;
                      this.getMunicipiosPrestador()
                      this.cidade = success.body.municipio;
                    }
                  });
                }
            },
    buscaReceitaTomador() {
        if (this.editedItem.cnpjCpfTomador){
              this.service.getAPIReceita(this.editedItem.cnpjCpfTomador).then(success => {
                    if (
                      success &&
                      success.status == 200 &&
                      success.body.status != "ERROR"
                    ) {
                      this.editedItem.razaoTomador = success.body.nome;
                      this.editedItem.enderecoTomadorLogradouro = success.body.logradouro;
                      this.editedItem.enderecoTomadorCEP = success.body.cep;
                      this.editedItem.enderecoTomadorBairro = success.body.bairro;
                      this.editedItem.inscTomador = success.body.inscricao_municipal;
                      this.editedItem.inscriEsTomador = success.body.inscricao_estadual;
                      this.editedItem.telefoneTomador = success.body.telefone;
                      this.editedItem.emailTomador = success.body.email;
                      this.editedItem.enderecoTomadorComplementoEndereco = success.body.complemento;
                      
                      let auxEstado;
                      this.uf = this.arrayEstados.forEach(item => {
                        if (item.sigla == success.body.uf) {
                          auxEstado = item;
                        }
                      });
                      this.estadoTomador = auxEstado;
                      this.getMunicipiosTomador()
                      this.cidadeTomador = success.body.municipio;
                    }
                  });
        }
    },
    getEstados: async function () {
      this.arrayMunicipiosPrestador = [];
      this.arrayMunicipiosTomador = [];
      this.resource = this.$resource(
        "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
      );
      this.resource.query().then(
        success => {
          
          this.arrayMunicipiosPrestador = [];
          this.arrayMunicipiosTomador = [];
          this.arrayEstados = success.body;

          return success.body;
        },
        failed => {
          this.arrayEstados = [{"id":11,"sigla":"RO","nome":"Rondônia","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":12,"sigla":"AC","nome":"Acre","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":13,"sigla":"AM","nome":"Amazonas","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":14,"sigla":"RR","nome":"Roraima","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":15,"sigla":"PA","nome":"Pará","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":16,"sigla":"AP","nome":"Amapá","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":17,"sigla":"TO","nome":"Tocantins","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":21,"sigla":"MA","nome":"Maranhão","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":22,"sigla":"PI","nome":"Piauí","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":23,"sigla":"CE","nome":"Ceará","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":24,"sigla":"RN","nome":"Rio Grande do Norte","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":25,"sigla":"PB","nome":"Paraíba","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":26,"sigla":"PE","nome":"Pernambuco","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":27,"sigla":"AL","nome":"Alagoas","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":28,"sigla":"SE","nome":"Sergipe","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":29,"sigla":"BA","nome":"Bahia","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":31,"sigla":"MG","nome":"Minas Gerais","regiao":{"id":3,"sigla":"SE","nome":"Sudeste"}},{"id":32,"sigla":"ES","nome":"Espírito Santo","regiao":{"id":3,"sigla":"SE","nome":"Sudeste"}},{"id":33,"sigla":"RJ","nome":"Rio de Janeiro","regiao":{"id":3,"sigla":"SE","nome":"Sudeste"}},{"id":35,"sigla":"SP","nome":"São Paulo","regiao":{"id":3,"sigla":"SE","nome":"Sudeste"}},{"id":41,"sigla":"PR","nome":"Paraná","regiao":{"id":4,"sigla":"S","nome":"Sul"}},{"id":42,"sigla":"SC","nome":"Santa Catarina","regiao":{"id":4,"sigla":"S","nome":"Sul"}},{"id":43,"sigla":"RS","nome":"Rio Grande do Sul","regiao":{"id":4,"sigla":"S","nome":"Sul"}},{"id":50,"sigla":"MS","nome":"Mato Grosso do Sul","regiao":{"id":5,"sigla":"CO","nome":"Centro-Oeste"}},{"id":51,"sigla":"MT","nome":"Mato Grosso","regiao":{"id":5,"sigla":"CO","nome":"Centro-Oeste"}},{"id":52,"sigla":"GO","nome":"Goiás","regiao":{"id":5,"sigla":"CO","nome":"Centro-Oeste"}},{"id":53,"sigla":"DF","nome":"Distrito Federal","regiao":{"id":5,"sigla":"CO","nome":"Centro-Oeste"}}];
          return this.arrayEstados;
        }
      );
    },
    validationRules() {
      return [
        v => !!v || "Campo obrigatório",
      ]
    },
    validaEmail() {
      const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return [
        v => {
          if (v && !regex.test(v)) {
            this.emailInvalido = true;
            return "Email Inválido!";
          }
          this.emailInvalido = false;
          return true;
        },
      ]
    }
  },
  methods: {
    cnpjCpfInvalido: function (v, booleanValue) {
      if (v === this.editedItem.cnpjCpfPrestador) {
        this.docPrestador = booleanValue
      }

      if (v === this.editedItem.cnpjCpfTomador) {
        this.docTomador = booleanValue
      }
    },
    getMunicipiosTomador: async function (codMun = '') {
      if (this.estadoTomador) {
        this.resource = this.$resource(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.estadoTomador.id}/municipios`
        );
        this.resource.query().then(
          success => {
            if (codMun) {
              if (success.body.length) {
                for (let i in success.body) {
                  if (success.body[i].id == codMun) {
                    this.cidadeTomador = success.body[i];
                    break;
                  }
                }
              }
            }
            this.arrayMunicipiosTomador = success.body;
          },
          failed => {
            this.arrayMunicipiosTomador = [];
          }
        );
      }
      else {
        return;
      }
    },
    getMunicipiosPrestador: async function (codMun = '') {
      if (this.estado) {
        this.resource = this.$resource(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.estado.id}/municipios`
        );
        this.resource.query().then(
          success => {
            if (codMun && codMun != 'None') {
              if (success.body.length) {
                for (let i in success.body) {
                  if (success.body[i].id == codMun) {
                    this.cidade = success.body[i];
                    break;
                  }
                }
              }
            }else if (this.cidade) {
              if (success.body.length) {
                for (let j in success.body) {
                  if (success.body[j].nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z0-9ÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÑÕÄËÏÖÜÇ]/ig, "") == this.cidade.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z0-9ÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÑÕÄËÏÖÜÇ]/ig, "")) {
                    this.cidade = success.body[j];
                    break;
                  }
                }
              }
            }
            this.arrayMunicipiosPrestador = success.body;
            this.regra_verifica_duplicidade()
          },
          failed => {
            this.arrayMunicipiosPrestador = [];
          }
        );
      }
      else {
        return;
      }
    },

    regra_verifica_duplicidade() {
      console.log('entrou');
      if (!this.docPrestador || !this.cidade || !this.editedItem.numeroNfe || !this.editedItem.codVerificacao) {
        this.desabilita_campo = true

      }
      else {
        // this.desabilita_campo = false
        this.VeriricaDuplicidade()


      }

    },
    async vOcrUpdate() {
      const verified = this.verificado ? this.verificado === 'Sim' ? true : false : '';
      this.isLoading = true;
      const response = await getNfseOcr(this.dataIni, this.dataFim, this.cnpj, verified, this.status_ocr);
      if (response) {
        this.body = response.nfse;
        this.pagination.totalItems = response.nfse.length;
        this.isLoading = false;
      } else {
        this.isLoading = false;
        alert('Erro ao buscar as notas.');
      }
    },
    async vOcrSevenDays() {
      const verified = this.verificado ? this.verificado === 'Sim' ? true : false : '';
      this.isLoading = true;
      const days = 7;
      const date = new Date();
      const last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
      const day = last.getDate();
      const month = last.getMonth() + 1;
      const year = last.getFullYear();

      const dtIni = `${day && String(day).length === 1 ? '0' + day : day}-${month}-${year}`;
      const dtFim = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;

      const response = await getNfseOcr(dtIni, dtFim, this.cnpj, verified, this.status_ocr);

      if (response) {
        this.body = response.nfse;
        this.pagination.totalItems = response.nfse.length;
        this.isLoading = false;
      } else {
        this.isLoading = false;
        alert('Erro ao buscar as notas.');
      }
    },
    async vOcrCurrentMonth() {
      const verified = this.verificado ? this.verificado === 'Sim' ? true : false : '';
      this.isLoading = true;
      const date = new Date();
      const dtIni = `01-${date.getMonth() + 1}-${date.getFullYear()}`;
      const dtFim = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;

      const response = await getNfseOcr(dtIni, dtFim, this.cnpj, verified, this.status_ocr);

      if (response) {
        this.body = response.nfse;
        this.pagination.totalItems = response.nfse.length;
        this.isLoading = false;
      } else {
        this.isLoading = false;
        alert('Erro ao buscar as notas.');
      }
    },
    async vOcrLastMonth() {
      const verified = this.verificado ? this.verificado === 'Sim' ? true : false : '';
      this.isLoading = true;
      const date = new Date();
      const lastDay = new Date(2008, date.getMonth(), 0);
      const dtIni = `01-${date.getMonth()}-${date.getFullYear()}`;
      const dtFim = `${lastDay.getDate().toString()}-${date.getMonth()}-${date.getFullYear()}`;

      const response = await getNfseOcr(dtIni, dtFim, this.cnpj, verified, this.status_ocr);

      if (response) {
        this.body = response.nfse;
        this.pagination.totalItems = response.nfse.length;
        this.isLoading = false;
      } else {
        this.isLoading = false;
        alert('Erro ao buscar as notas.');
      }
    },
    async vOcrOpenFile(item) {
      console.log(item);
      this.isFileLoading = true;
      this.cidade = '';
      this.estado = '';
      this.estadoTomador = '';
      this.cidadeTomador = '';


      if (!item || !item.pathPdf) {
        alert('Arquivo não encontrado');
        this.isFileLoading = false;
        return;
      }

      const response = await getFileOcr(item._id);

      if (response) {
        this.ocrFile = response.pdfBase64.conteudo;
        this.editedIndex = this.body.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.editedItem.enderecoPrestadorNumeroEndereco =  item.enderecoPrestador && item.enderecoPrestador.NumeroEndereco ? item.enderecoPrestador.NumeroEndereco : '';
        this.editedItem.enderecoPrestadorTipoLogradouro = item.enderecoPrestador && item.enderecoPrestador.TipoLogradouro ? item.enderecoPrestador.TipoLogradouro : '';
        this.editedItem.enderecoPrestadorLogradouro = item.enderecoPrestador && item.enderecoPrestador.Logradouro ? item.enderecoPrestador.Logradouro : '';
        this.editedItem.enderecoPrestadorComplementoEndereco = item.enderecoPrestador && item.enderecoPrestador.ComplementoEndereco ? item.enderecoPrestador.ComplementoEndereco : '';
        this.editedItem.enderecoPrestadorBairro = item.enderecoPrestador && item.enderecoPrestador.Bairro ? item.enderecoPrestador.Bairro : '';
        this.editedItem.enderecoPrestadorCEP = item.enderecoPrestador && item.enderecoPrestador.CEP ? item.enderecoPrestador.CEP : '';


        this.editedItem.enderecoTomadorTipoLogradouro = item.enderecoTomador && item.enderecoTomador.TipoLogradouro ? item.enderecoTomador.TipoLogradouro : '';
        this.editedItem.enderecoTomadorNumeroEndereco = item.enderecoTomador && item.enderecoTomador.NumeroEndereco ? item.enderecoTomador.NumeroEndereco : '';
        this.editedItem.enderecoTomadorBairro = item.enderecoTomador && item.enderecoTomador.Bairro ? item.enderecoTomador.Bairro : '';
        this.editedItem.enderecoTomadorLogradouro = item.enderecoTomador && item.enderecoTomador.Logradouro ? item.enderecoTomador.Logradouro : '';
        this.editedItem.enderecoTomadorComplementoEndereco = item.enderecoTomador && item.enderecoTomador.ComplementoEndereco ? item.enderecoTomador.ComplementoEndereco : '';
        this.editedItem.enderecoTomadorCEP = item.enderecoTomador && item.enderecoTomador.CEP ? item.enderecoTomador.CEP : '';

        if (this.editedItem && this.editedItem.cnpjCpfPrestador && this.editedItem.cnpjCpfPrestador.length > 11) {
          this.mask.cnpjPrestador = "##.###.###/####-##";
        } else if (this.editedItem && !this.editedItem.cnpjCpfPrestador) {
          this.mask.cnpjPrestador = "##.###.###/####-##";
        } else {
          this.mask.cnpjPrestador = "###.###.###-##";
        }

        if (this.editedItem && this.editedItem.cnpjCpfTomador && this.editedItem.cnpjCpfTomador.length > 11) {
          this.mask.cnpjTomador = "##.###.###/####-##";
        } else if (this.editedItem && !this.editedItem.cnpjCpfTomador) {
          this.mask.cnpjTomador = "##.###.###/####-##";
        } else {
          this.mask.cnpjTomador = "###.###.###-##";
        }

        for (let i in this.arrayEstados) {
          if (this.arrayEstados[i].sigla === this.editedItem.UFPrestador) {
            this.estado = this.arrayEstados[i];
            this.getMunicipiosPrestador(this.editedItem.codMun);
            break;
          }
        }
        
        if (this.editedItem.enderecoTomador && this.editedItem.enderecoTomador.UF){

          for (let i in this.arrayEstados) {
            if (this.arrayEstados[i].sigla === this.editedItem.enderecoTomador.UF) {
              this.estadoTomador = this.arrayEstados[i];
              
              this.getMunicipiosTomador(this.editedItem.enderecoTomador.codMun);
              break;
            }
            
          }
        }


        this.dialog = true;
        this.isFileLoading = false;
        if (response.pdfBase64.status == 'falha') {
          alert(response.pdfBase64.mensagem);
        }

      } else {
        this.isFileLoading = false;
        alert('Erro ao abrir a nota.');
      }
    },
    async VeriricaDuplicidade() {
      this.isBtnLoading = true;
      let auxList = this.body;

      await this.handleFields();

      const response = await verifyDuplicate(this.editedItem.numeroNfe,
        this.editedItem.codVerificacao, this.editedItem.cnpjCpfPrestador,
        this.editedItem.codMun, this.editedItem._id, this.conta.id_usuario);

      if (response && response.MESSAGE !== 'NOTA SEM DUPLICIDADE') {
        auxList[this.editedIndex] = this.editedItem;

        if (response.STATUS === 'Duplicada') {
          auxList[this.editedIndex].ocr_status = "Duplicada";
        }

        if (response.STATUS === 'Falha') {
          auxList[this.editedIndex].ocr_status = "Falha";
        }

        auxList[this.editedIndex].verificadoOcr = true;
        this.body = [];

        setTimeout(() => {
          this.body = auxList;
          this.dialog = false;
          this.isBtnLoading = false;
          this.errorMessage = 'Nota Existente no motor "Duplicada"!';
          setTimeout(() => {
            this.errorMessage = '';
          }, 6000);
        }, 2000);
      } else {
        this.isBtnLoading = false;
        this.desabilita_campo = false

        this.successMessageDuplicidade = 'Nota não existente no motor!';
        setTimeout(() => {
          this.successMessageDuplicidade = '';
        }, 6000);

      }
    },
    async vOcrSave() {
      if(this.editedItem.emailInvalido) {
        alert('Informe um E-mail válido.')
        return
      }
      this.isBtnLoading = true;
      let auxList = this.body;

      await this.handleFields();

      const response = await saveOcr(this.editedItem, this.conta.id_usuario);

      if (response && response.STATUS) {
        auxList[this.editedIndex] = this.editedItem;

        if (response.STATUS === 'Duplicada') {
          auxList[this.editedIndex].ocr_status = "Duplicada";
        }

        if (response.STATUS === 'Falha') {
          auxList[this.editedIndex].ocr_status = "Falha";
        }

        auxList[this.editedIndex].verificadoOcr = true;
        this.body = [];

        setTimeout(() => {
          this.body = auxList;
          this.dialog = false;
          this.isBtnLoading = false;
          this.successMessage = 'NFSe salva!';
          setTimeout(() => {
            this.successMessage = '';
          }, 3000);
        }, 500);
      } else {
        this.isBtnLoading = false;
        alert('Erro ao salvar.');
      }
    },
    async handleFields() {
      this.editedItem.codVerificacao = this.editedItem.codVerificacao ? this.editedItem.codVerificacao.toUpperCase() : '';
      this.editedItem.serie = this.editedItem.serie ? this.editedItem.serie : '';
      this.editedItem.codMun = this.cidade && this.cidade.id ? this.cidade.id : '';
      this.editedItem.cidade = this.cidade && this.cidade.nome ? this.cidade.nome : '';
      this.editedItem.UFPrestador = this.estado && this.estado.sigla ? this.estado.sigla : '';
      this.editedItem.municipio = this.cidadeTomador && this.cidadeTomador.nome ? this.cidadeTomador.nome : '';
      this.editedItem.estado = this.estado && this.estado.sigla ? this.estado.sigla : '';
      this.editedItem.razaoSocial = this.editedItem.razaoTomador ? this.editedItem.razaoTomador : '';
      this.editedItem.enderecoTomador = {};
      this.editedItem.enderecoTomador.TipoLogradouro = this.editedItem.enderecoTomadorTipoLogradouro ? this.editedItem.enderecoTomadorTipoLogradouro : '';
      this.editedItem.enderecoTomador.Logradouro = this.editedItem.enderecoTomadorLogradouro ? this.editedItem.enderecoTomadorLogradouro : '';
      this.editedItem.enderecoTomador.NumeroEndereco = this.editedItem.enderecoTomadorNumeroEndereco ? this.editedItem.enderecoTomadorNumeroEndereco : '';
      this.editedItem.enderecoTomador.ComplementoEndereco = this.editedItem.enderecoTomadorComplementoEndereco ? this.editedItem.enderecoTomadorComplementoEndereco : '';
      this.editedItem.enderecoTomador.Bairro = this.editedItem.enderecoTomadorBairro ? this.editedItem.enderecoTomadorBairro : '';
      this.editedItem.enderecoTomador.Cidade = this.cidadeTomador && this.cidadeTomador.nome ? this.cidadeTomador.nome : '';
      this.editedItem.enderecoTomador.codMun = this.cidadeTomador && this.cidadeTomador.id ? this.cidadeTomador.id : '';
      this.editedItem.enderecoTomador.UF = this.estadoTomador && this.estadoTomador.sigla ? this.estadoTomador.sigla : '';
      this.editedItem.enderecoTomador.CEP = this.editedItem.enderecoTomadorCEP ? this.editedItem.enderecoTomadorCEP : '';

      this.editedItem.enderecoPrestador = {};
      this.editedItem.enderecoPrestador.TipoLogradouro = this.editedItem.enderecoPrestadorTipoLogradouro ? this.editedItem.enderecoPrestadorTipoLogradouro : '';
      this.editedItem.enderecoPrestador.Logradouro = this.editedItem.enderecoPrestadorLogradouro ? this.editedItem.enderecoPrestadorLogradouro : '';
      this.editedItem.enderecoPrestador.NumeroEndereco = this.editedItem.enderecoPrestadorNumeroEndereco ? this.editedItem.enderecoPrestadorNumeroEndereco : '';
      this.editedItem.enderecoPrestador.ComplementoEndereco = this.editedItem.enderecoPrestadorComplementoEndereco ? this.editedItem.enderecoPrestadorComplementoEndereco : '';
      this.editedItem.enderecoPrestador.Bairro = this.editedItem.enderecoPrestadorBairro ? this.editedItem.enderecoPrestadorBairro : '';
      this.editedItem.enderecoPrestador.Cidade = this.cidade && this.cidade.nome ? this.cidade.nome : '';
      this.editedItem.enderecoPrestador.UF = this.estado && this.estado.sigla ? this.estado.sigla : '';
      this.editedItem.enderecoPrestador.CEP = this.editedItem.enderecoPrestadorCEP ? this.editedItem.enderecoPrestadorCEP : '';

      this.editedItem.cnpj = this.editedItem.cnpjCpfTomador ? this.editedItem.cnpjCpfTomador : '';
      this.editedItem.inscriEsPrestador = this.editedItem && this.editedItem.inscriEsPrestador ? this.editedItem.inscriEsPrestador : '';
      this.editedItem.cepPrestador = this.editedItem && this.editedItem.cepPrestador ? this.editedItem.cepPrestador : '';
      this.editedItem.telefonePrestador = this.editedItem && this.editedItem.telefonePrestador ? this.editedItem.telefonePrestador : '';
      this.editedItem.emailPrestador = this.editedItem && this.editedItem.emailPrestador ? this.editedItem.emailPrestador : '';
      this.editedItem.ISSRetido = this.editedItem.ISSRetido && this.editedItem.ISSRetido === 'true' ? 'true' : 'false';
      this.editedItem.opcaoSimples = this.editedItem.opcaoSimples ? this.editedItem.opcaoSimples : '5';
      this.editedItem.tribNfe = this.editedItem.tribNfe ? this.editedItem.tribNfe : 'U0';
      this.editedItem.totalImpostos = this.editedItem.aliqServico ? this.editedItem.aliqServico.replaceAll('.', '').replace(',', '.') : '';
      this.editedItem.deducoes = this.editedItem.deducoes ? this.editedItem.deducoes : ''

      if (this.editedItem.IR && String(this.editedItem.IR).includes(',')) {
        this.editedItem.IR = this.editedItem.IR.replaceAll('.', '').replace(',', '.');
      }
      if (this.editedItem.COFINS && String(this.editedItem.COFINS).includes(',')) {
        this.editedItem.COFINS = this.editedItem.COFINS.replaceAll('.', '').replace(',', '.');
      }
      if (this.editedItem.CSLL && String(this.editedItem.CSLL).includes(',')) {
        this.editedItem.CSLL = this.editedItem.CSLL.replaceAll('.', '').replace(',', '.');
      }
      if (this.editedItem.INSS && String(this.editedItem.INSS).includes(',')) {
        this.editedItem.INSS = this.editedItem.INSS.replaceAll('.', '').replace(',', '.');
      }
      if (this.editedItem.ISS && String(this.editedItem.ISS).includes(',')) {
        this.editedItem.ISS = this.editedItem.ISS.replaceAll('.', '').replace(',', '.');
      }
      if (this.editedItem.PIS && String(this.editedItem.PIS).includes(',')) {
        this.editedItem.PIS = this.editedItem.PIS.replaceAll('.', '').replace(',', '.');
      }
      if (this.editedItem.aliqServico && String(this.editedItem.aliqServico).includes(',')) {
        this.editedItem.aliqServico = this.editedItem.aliqServico.replaceAll('.', '').replace(',', '.');
      }
      if (this.editedItem.vlrCredito && String(this.editedItem.vlrCredito).includes(',')) {
        this.editedItem.vlrCredito = this.editedItem.vlrCredito.replaceAll('.', '').replace(',', '.');
      }
      if (this.editedItem.vlrServico && String(this.editedItem.vlrServico).includes(',')) {
        this.editedItem.vlrServico = this.editedItem.vlrServico.replaceAll('.', '').replace(',', '.');
      }
    },
    async vOcrVerify() {
      this.isBtnLoading = true;
      let auxList = this.body;
      const response = await verifyOcr(this.editedItem._id, this.conta.id_usuario);

      if (response) {
        auxList[this.editedIndex].verificadoOcr = true;
        this.body = [];
        this.body = auxList;
        this.dialog = false;
        this.isBtnLoading = false;
        this.successMessage = 'NFSe verificada!';
        setTimeout(() => {
          this.successMessage = '';
        }, 3000);
      } else {
        this.isBtnLoading = false;
        alert('Erro ao verificar.');
      }
    },
    vOcrClear() {
      this.dataIni = '';
      this.dataFim = '';
      this.cnpj = '';
      this.verificado = '';
    },
    async vOcrAlterState(state) {
      console.log(this.conta)
      this.isBtnLoading = true;
      let auxList = this.body;
      const response = await denyOcr(this.editedItem._id, state, this.conta.id_usuario);

      if (response) {
        auxList[this.editedIndex].verificadoOcr = true;
        auxList[this.editedIndex].ocr_status = state;
        this.body = [];
        this.body = auxList;
        this.dialog = false;
        this.isBtnLoading = false;
        this.successMessage = `NFSe ${state}!`;
        setTimeout(() => {
          this.successMessage = '';
        }, 3000);
      } else {
        this.isBtnLoading = false;
        alert(`Erro ao ${state}.`);
      }
    },
    trocaCampoCpfCnpjPrestador: function (e, v) {
      if (!v || (v && v.length == 0)) {
        this.mask.cnpjPrestador = "";
      } else {
        if (this.trocaCPFCNPJ && v && v.length >= 12) {
          this.mask.cnpjPrestador = "##.###.###/####-##";
        } else if (v && v.length <= 11) {
          this.trocaCPFCNPJ = true;
          this.mask.cnpjPrestador = "###.###.###-###";
        } else {
          this.trocaCPFCNPJ = false;
          this.mask.cnpjPrestador = "##.###.###/####-##";
        }
      }
    },
    trocaCampoCpfCnpjTomador: function (e, v) {
      if (!v || (v && v.length == 0)) {
        this.mask.cnpjTomador = "";
      } else {
        if (this.trocaCPFCNPJ && v && v.length >= 12) {
          this.mask.cnpjTomador = "##.###.###/####-##";
        } else if (v && v.length <= 11) {
          this.trocaCPFCNPJ = true;
          this.mask.cnpjTomador = "###.###.###-###";
        } else {
          this.trocaCPFCNPJ = false;
          this.mask.cnpjTomador = "##.###.###/####-##";
        }
      }
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        console.log("Form submitted");
      }
    },
  }
};
</script>
<style scoped>
/* #ocrTable thead tr {
  height: 40px!important;
}

table.v-table thead tr {
  height: 40px!important;
} */

.cont-ocr {
  position: absolute;
  background: #000000d4;
  width: 100vw;
  top: 0px;
  bottom: 0;
}

.load-ocr {
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
}

.ocrLink {
  color: teal;
  cursor: pointer;
}

.ocrLink:hover {
  text-decoration: underline;
}

h1,
h2 {
  font-weight: normal;
}

.descTable {
  background-color: rgb(0, 150, 136) !important;
  margin: 0 0 39px 0px;
}

.c_line_title {
  background-color: #499292;
  color: white;
  padding: 6px;
  position: relative;
}

.title_click {
  cursor: pointer;
}

.body_lista {
  background-color: #d7d7d7;
  border: thin solid black;
  min-height: 232px;
}

.body_lista_logins {
  max-height: 99px;
  overflow-y: scroll;
  background-color: #ececec;
  border: thin solid #c5c5c5;
}

.body_lista_logins::-webkit-scrollbar {
  width: 8px;
  height: 14px;
}

.body_lista ul {
  list-style: none;
}

.body_lista ul li {
  padding: 6px;
}

@-webkit-keyframes loading {
  from {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loading {
  from {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.slide-fade-enter-active {
  opacity: 1;
  transition: all 0.3s cubic-bezier(0, 1.11, 0.83, 0.67);
}

.slide-fade-leave-active {
  opacity: 0;
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active em versões anteriores a 2.1.8 */
  {
  transform: translateX(10px);
  opacity: 0;
}

.translate-y-fade-enter-active {
  opacity: 1;
  transition: all 3s cubic-bezier(0, 1.11, 0.83, 0.67);
}

.translate-y-fade-leave-active {
  opacity: 0;
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.translate-y-fade-enter,
.translate-y-fade-leave-to

/* .slide-fade-leave-active em versões anteriores a 2.1.8 */
  {
  transform: scaleY(1);
  opacity: 0;
}

.loading {
  animation-name: loading;
  animation: loading 2s infinite;
}

.valor_do_campo {
  font-size: 0.9em;
  color: #4d627b;
  opacity: 0.75;
  text-overflow: ellipsis !important;
  white-space: nowrap;
  overflow: hidden;
  min-width: 100px;
  width: 102px;
}</style>


// WEBPACK FOOTER //
// src/pages/loggedArea/validaOcr/ValidaOcr.vue